import React, { ReactNode } from 'react'
import 'src/components/shared/FlowTypeIcon.css'
import { ArrowRightEndOnRectangleIcon, ArrowRightStartOnRectangleIcon } from '@heroicons/react/24/outline'

type props = {
  flowType: string
}

const FlowTypeTag: React.FC<props> = ({ flowType }) => {
  return <div className={`flow-type-tag ${flowType}`}>{iconMap[flowType]} {(flowType || '').toUpperCase()}</div>
}
const iconMap: Record<string, ReactNode> = {
  'in': <ArrowRightEndOnRectangleIcon className="icon in" />,
  'out': <ArrowRightStartOnRectangleIcon className="icon out" />,
}

export default FlowTypeTag
